import { Middleware } from "@reduxjs/toolkit";
import { showLoading, hideLoading } from "../reducers/loading/loadingSlice";

/** Must match `reducerPath` in `services/baseApi.ts` (e.g. `api/executeQuery/pending`). */
const RTK_QUERY_ACTION_PREFIX = "api/";

/** In-flight non-RTK async work using the `/pending` → `/fulfilled` pattern (e.g. legacy thunks). */
let pendingLoadingDepth = 0;

export const apiMiddleware: Middleware =
  ({ dispatch }) =>
  (next) =>
  (action: unknown) => {
    if (
      typeof action === "object" &&
      action !== null &&
      "type" in action &&
      typeof (action as { type: string }).type === "string"
    ) {
      const type = (action as { type: string }).type;
      // RTK Query emits /pending and /fulfilled per endpoint. Feeding those into this
      // counter makes depth hit 0 between staggered requests and flashes GlobalSpin on
      // navigation. Data loading uses per-hook `isLoading` instead.
      if (type.startsWith(RTK_QUERY_ACTION_PREFIX)) {
        return next(action);
      }
      if (type.endsWith("/pending")) {
        pendingLoadingDepth += 1;
        if (pendingLoadingDepth === 1) {
          dispatch(showLoading());
        }
      } else if (type.endsWith("/fulfilled") || type.endsWith("/rejected")) {
        pendingLoadingDepth = Math.max(0, pendingLoadingDepth - 1);
        if (pendingLoadingDepth === 0) {
          dispatch(hideLoading());
        }
      }
    }

    return next(action);
  };
